/**
 * Centralized name display utilities for FamilyMember.
 *
 * Nickname replaces firstName wherever members are displayed.
 * e.g., member with nickname "JJ", lastName "Redd" → "JJ Redd"
 *
 * NOT used for:
 * - Header/nav (shows User account name)
 * - Financial contexts (Stripe, receipts — uses legal name)
 */

interface MemberNameFields {
  firstName: string;
  lastName: string;
  nickname?: string | null;
}

/** Full display name — nickname replaces firstName when available */
export function getMemberDisplayName(
  member: Pick<MemberNameFields, 'firstName' | 'lastName' | 'nickname'>
): string {
  const displayFirst = member.nickname || member.firstName;
  return `${displayFirst} ${member.lastName}`;
}

/** Display first name only (nickname if available, otherwise firstName) */
export function getMemberDisplayFirstName(
  member: Pick<MemberNameFields, 'firstName' | 'nickname'>
): string {
  return member.nickname || member.firstName;
}

/** Avatar initials using nickname when available */
export function getMemberInitials(
  member: Pick<MemberNameFields, 'firstName' | 'lastName' | 'nickname'>
): string {
  const displayFirst = member.nickname || member.firstName;
  return `${displayFirst.charAt(0)}${member.lastName.charAt(0)}`.toUpperCase();
}
